import type { RouteObject } from 'react-router';
import { ForgotPasswordPage, RequireAuth, ResetPasswordPage } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const PatronLoginPage = lazyNamed(() => import('./pages'), 'PatronLoginPage');
const AccountLayout = lazyNamed(() => import('./pages'), 'AccountLayout');
const HomePage = lazyNamed(() => import('./pages'), 'HomePage');
const SearchPage = lazyNamed(() => import('./pages'), 'SearchPage');
const BookDetailPage = lazyNamed(() => import('./pages'), 'BookDetailPage');
const BrowsePage = lazyNamed(() => import('./pages'), 'BrowsePage');
const PublicListsPage = lazyNamed(() => import('./pages'), 'PublicListsPage');
const PublicListDetailPage = lazyNamed(() => import('./pages'), 'PublicListDetailPage');
const PublicEventsPage = lazyNamed(() => import('./pages'), 'PublicEventsPage');
const PublicEventDetailPage = lazyNamed(() => import('./pages'), 'PublicEventDetailPage');
const PublicRoomsPage = lazyNamed(() => import('./pages'), 'PublicRoomsPage');
const PublicCoursesPage = lazyNamed(() => import('./pages'), 'PublicCoursesPage');
const ResourcesPage = lazyNamed(() => import('./pages'), 'ResourcesPage');
const RegisterPage = lazyNamed(() => import('./pages'), 'RegisterPage');
const AccountHomePage = lazyNamed(() => import('./pages'), 'AccountHomePage');
const AccountLoansPage = lazyNamed(() => import('./pages'), 'AccountLoansPage');
const AccountHoldsPage = lazyNamed(() => import('./pages'), 'AccountHoldsPage');
const AccountFinesPage = lazyNamed(() => import('./pages'), 'AccountFinesPage');
const AccountHistoryPage = lazyNamed(() => import('./pages'), 'AccountHistoryPage');
const AccountListsPage = lazyNamed(() => import('./pages'), 'AccountListsPage');
const AccountSuggestionsPage = lazyNamed(() => import('./pages'), 'AccountSuggestionsPage');
const AccountIllPage = lazyNamed(() => import('./pages'), 'AccountIllPage');
const AccountEventsPage = lazyNamed(() => import('./pages'), 'AccountEventsPage');
const AccountProfilePage = lazyNamed(() => import('./pages'), 'AccountProfilePage');
const AccountNotificationsPage = lazyNamed(() => import('./pages'), 'AccountNotificationsPage');
const AccountPreferencesPage = lazyNamed(() => import('./pages'), 'AccountPreferencesPage');
const KioskHomePage = lazyNamed(() => import('./pages'), 'KioskHomePage');

/** Public OPAC pages, rendered inside PublicShell. Paths are absolute from the site root. */
export const opacRoutes: RouteObject[] = [
  { index: true, element: <HomePage /> },
  { path: 'search', element: <SearchPage /> },
  { path: 'book/:id', element: <BookDetailPage /> },
  { path: 'browse', element: <BrowsePage /> },
  { path: 'lists', element: <PublicListsPage /> },
  { path: 'lists/shared/:token', element: <PublicListDetailPage /> },
  { path: 'lists/:id', element: <PublicListDetailPage /> },
  { path: 'events', element: <PublicEventsPage /> },
  { path: 'events/:id', element: <PublicEventDetailPage /> },
  { path: 'rooms', element: <PublicRoomsPage /> },
  { path: 'courses', element: <PublicCoursesPage /> },
  { path: 'resources', element: <ResourcesPage /> },
  {
    path: 'account',
    element: (
      <RequireAuth>
        <AccountLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <AccountHomePage /> },
      { path: 'loans', element: <AccountLoansPage /> },
      { path: 'holds', element: <AccountHoldsPage /> },
      { path: 'fines', element: <AccountFinesPage /> },
      { path: 'history', element: <AccountHistoryPage /> },
      { path: 'lists', element: <AccountListsPage /> },
      { path: 'suggestions', element: <AccountSuggestionsPage /> },
      { path: 'ill', element: <AccountIllPage /> },
      { path: 'events', element: <AccountEventsPage /> },
      { path: 'profile', element: <AccountProfilePage /> },
      { path: 'notifications', element: <AccountNotificationsPage /> },
      { path: 'preferences', element: <AccountPreferencesPage /> },
    ],
  },
];

/** Standalone auth screens (no shell): /login, /register, /forgot-password, /reset-password. */
export const opacAuthRoutes: RouteObject[] = [
  { path: 'login', element: <PatronLoginPage /> },
  { path: 'register', element: <RegisterPage /> },
  { path: 'forgot-password', element: <ForgotPasswordPage /> },
  { path: 'reset-password', element: <ResetPasswordPage /> },
];

/** Fullscreen self-checkout, rendered inside KioskShell at /kiosk. */
export const kioskRoutes: RouteObject[] = [{ index: true, element: <KioskHomePage /> }];
